import React from 'react';

// @TODO Make the year dynamic
const Footer = () => (
  <footer className="footer">
    <div className="copyright">&copy; 2018 Huvercraft</div>
    <div className="report-print-notice">Report generated by Huvercraft</div>
  </footer>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/Components/Footer/Footer.js